export default {"src":"/_next/static/media/payment_processing.03b984e5.gif","height":2747,"width":4704,"blurWidth":0,"blurHeight":0};